<template>
  <div class="header">
    <div class="header_container">
        <a href="http://pmglab.top" ><img :src="pmg_logo_src" class="tool_logo"></a>
        <p v-html="title"></p>
        <!-- <a href="./" ><img :src="pmg_logo_src" class="lab_logo"></a> -->
    </div>
  </div>
</template>

<script>

import pmg_log from '@/assets/img/pmg_logo_rev.png';
export default {
  name: 'navi',
    props:["currentPage"],
  data () {
    return {
      pmg_logo_src:pmg_log,
      title:"Phased Genotypes for Genome-wide Genetic studies",
      navi_items: {
        '':'Home',
        'download':'Download',
        // 'tutorial':'Tutorial',
        'manual':'Online Manual',
        'follow':'Follow us'
      },
      links:{
        'follow':'http://pmglab.top/homepage',
        'download':'https://mailsysueducn-my.sharepoint.com/:u:/g/personal/limiaoxin_mail_sysu_edu_cn/EZxHcXiZfQRIi6T8jezSqo8Bf8-mfJZK4N0adtB8J6I79Q',
        // 'manunal':'./KGGSEE.html',
      },
      currentPage:''
    }
  },
  methods:{
    navi_go:function(navi_iterm){
      if(this.links.hasOwnProperty(navi_iterm)){
        window.open(this.links[navi_iterm])
      }else{
        this.$router.push({path:'/'+navi_iterm});
      }
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.header {

  /* border-top: solid #000000 4px;
  box-sizing: border-box; */
}
.header_container{
  height: 80px;
  background: #005826;
  margin: 0px;
  width: 1200px;
  position: fixed;
  top:0px;
  left: 0px;
  opacity: 1;
  z-index:100;

}

.tool_logo {
  height: 60px;
  margin: 10px 100px 5px 30px;
  float:left;
}

.lab_logo {
  height: 60px;
  margin: 10px 30px 5px 0px;
  float:right;
}
p {
  width: 780px;
  float: left;
  color: #FFFFFF;
  font-size: 26px;
  text-align: center;
  font-weight: bold;
/* margin-top: 16px; */
}

</style>



// WEBPACK FOOTER //
// src/components/header.vue